import React, { useState, useEffect } from 'react';
import { Input, Select } from 'antd';
import FormItem from 'src/components/form-item';
import { noop } from 'lodash';
import './style.scss';
import { useTranslation } from 'react-i18next';

const { Search } = Input;

/**
 * Filter component for searching responsibles.
 * @param {Object} props - The component props.
 * @param {Function} props.onSearch - The callback function for searching responsibles.
 * @param {Array} props.profileOptions - The options for the profile filter.
 * @returns {JSX.Element} The filter component.
 */
function Filters({ onSearch, profileOptions }) {
  const [loginFilter, setLoginFilter] = useState('');
  const [selectedProfile, setSelectedProfile] = useState('');

  const { t } = useTranslation();

  const enhancedProfileOptions = [
    { value: '', label: t('all') },
    ...profileOptions,
  ];

  useEffect(() => {
    onSearch(loginFilter, selectedProfile);
  }, [loginFilter, selectedProfile, onSearch]);

  return (
    <>
      <div className="profile-filter__container">
        <FormItem label="Login" id="people-search-field">
          <Search
            id="people-search-field"
            value={loginFilter}
            onChange={(e) => setLoginFilter(e.target.value)}
            placeholder={t('searchByLogin')}
            aria-label={t('loginFilter')}
            aria-labelledby="people-search-field"
          />
        </FormItem>
        <FormItem label={t('profile')} id="profile">
          <Select
            options={enhancedProfileOptions}
            onChange={(selectedValue) => setSelectedProfile(selectedValue)}
            aria-label={t('profileFilter')}
            placeholder={t('selectFilter')}
            aria-labelledby="profile"
          />
        </FormItem>
      </div>
    </>
  );
}

Filters.defaultProps = {
  onSearch: noop,
};

export default Filters;